<template>
    <header id="header">
        <header class="flex justify-start">
            <NuxtLink to= "/" class="h1 text-2xl flex items-center gap-4">
                <LogoLightSvg class="size-12" />
                <span class="justify-start text-navy-900 font-syne font-normal text-2xl">Augwa</span>
            </NuxtLink>
        </header>
    </header>
</template>

<script lang="ts" setup>
import LogoLightSvg from '~/assets/svg/logo_light.svg'
</script>
